import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

// Not shipped yet: the Coming soon state. Gated by the parent `/billing` route (`billing:list`); lazy-loaded.
export const Route = createFileRoute('/_authenticated/billing/emails')({
  component: lazyRouteComponent(() => import('&/features/billing/pages/billing-coming-soon-page'), 'EmailFailuresPage'),
  staticData: { titleKey: 'billingEmails' },
});
